module.exports = __webpack_public_path__ + "static/img/withered_skin-01.dc5b68e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/withered_skin-01.jpg
// module id = 300
// module chunks = 1